import DefaultLayout from './components/templates/default';

function App({ children }) {
  return <DefaultLayout />;
}

export default App;
